module.exports = __webpack_public_path__ + "img/ANCV.bd4c01a7.png";